import RecommendationResultV2 from './v2/result';

/**
 * "Recomendación de manejo" — the v2 result page bound to a saved `corn_density` record.
 *
 * The route keeps its old path, so the links the backend hands out and the ones already in the
 * wild keep working; only what it renders changed. `useSavedRecommendation` resolves the crop
 * config from the `corn_density` columns, which is why recommendations the retired density
 * wizard saved open here too.
 */
const ManagementRecommendationResult = ({ recommendationId }: { recommendationId: number }) => (
    <RecommendationResultV2 recommendationId={recommendationId} crop='corn' />
);

export default ManagementRecommendationResult;
